<template>
  <RygenChip
    class="shipment-tender-request-status-chip"
    :label="effectiveStatus.label"
    :severity="severity"
  />
</template>

<script lang="ts" setup>
import { computed, PropType, toRefs } from 'vue';

import { mapEnumToTranslatedDropdownValue } from '@rygen/rygen-ui/i18n';
import { Severity } from '@rygen/rygen-ui/model';

import { TenderResponseCode, TenderStatus } from '@/model';

import RygenChip from '@rygen/rygen-ui/components/ui/RygenChip.vue';

const props = defineProps({
  requestStatus: {
    type: String as PropType<TenderStatus>,
    default: () => 'LOADING',
  },
  responseCode: {
    type: String as PropType<TenderResponseCode>,
    default: () => undefined,
  },
});
const { requestStatus, responseCode } = toRefs(props);

const effectiveStatus = computed(() => {
  return responseCode?.value
    ? mapEnumToTranslatedDropdownValue(responseCode.value, 'TenderResponseCode')
    : mapEnumToTranslatedDropdownValue(requestStatus.value, 'TenderStatus');
});

const severity = computed((): Severity | undefined => {
  switch (effectiveStatus.value.value) {
    case TenderResponseCode.RESERVATION_ACCEPTED:
      return Severity.SUCCESS;
    case TenderResponseCode.RESERVATION_DECLINED:
      return Severity.DANGER;
    case TenderResponseCode.RESERVATION_PENDING:
    case TenderStatus.EXPIRED:
    case TenderStatus.CANCELED:
      return Severity.WARNING;
    case TenderStatus.AWAITING_RESPONSE:
    case TenderStatus.RESPONSE_RECEIVED:
      return Severity.INFO;
    default:
      return undefined;
  }
});
</script>
